// extracted by mini-css-extract-plugin
export default {"btnIcon":"CombineButtonContainer_btnIcon__hjaFY"};